import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=3d1c1cc0&"
import script from "./Archive.vue?vue&type=script&lang=ts&"
export * from "./Archive.vue?vue&type=script&lang=ts&"
import style0 from "./Archive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports